import React from 'react'
import { LoggedInPageLayout } from '@/components/layout/LoggedInLayout'
import { BackButton } from '@/components/layout/NavBar'
import { UDTMapComponent } from '@/components/Map/UDTMap'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'
import { useAppContext } from '@/context/app'

export function UDTMapPage({ services, session }: { services: Services, session: CurrentSession }) {
  const { translates } = useAppContext()
  const localizedSession = translates ? { ...session, translates } : session

  return <LoggedInPageLayout pageName='communal-udt-map' services={services} session={localizedSession}
    navbarLeft={<BackButton services={services} translates={localizedSession.translates} />}>
    <UDTMapComponent services={services} session={localizedSession} />
  </LoggedInPageLayout>
}
